import React from "react";
import { Card } from "reactstrap";
import Collapse from "../../../../shared/components/Collapse";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalendarBlankIcon, FilterIcon, CheckIcon } from "mdi-react";

export default class ProductsFilter extends React.Component {
  state = {};

  componentDidMount() {
    //this.setCurrentState();
    this.handleChange({
      startDate: this.props.state.startDate,
      endDate: this.props.state.endDate,
    });
  }

  shouldComponentUpdate = () => {
    // this.setCurrentState();
    return false;
  };

  setCurrentState = () => {
    if (this.state.type !== this.props.type) {
      this.setState({ type: this.props.type }, () => {
        let statuses = this.props.state.statuses;

        statuses.map((obj) => {
          obj.checked = obj.key.toLowerCase() === this.state.type.toLowerCase();
          return obj;
        });

        this.setState({ statuses }, () => {
          this.filter();
        });
      });
    }
  };

  filter = () => {
    let filters = {
      created: {
        from: this.props.state.startDate.format("YYYY/MM/DD"),
        to: this.props.state.endDate.format("YYYY/MM/DD"),
      },
    };

    if (this.state.name !== undefined && this.state.name.trim() !== "") {
      filters["name"] = this.state.name;
    }

    if (
      this.state.startDate !== undefined &&
      typeof this.state.startDate.format !== "undefined"
    ) {
      filters.created["from"] = this.state.startDate.format("YYYY/MM/DD");
    }

    if (
      this.state.endDate !== undefined &&
      typeof this.state.endDate.format !== "undefined"
    ) {
      filters.created["to"] = this.state.endDate.format("YYYY/MM/DD");
    }

    if (this.state.types !== undefined) {
      let types = [];
      this.state.types.forEach((type) => {
        if (type.checked) {
          types.push(type.key);
        }
      });

      if (types.length > 0) {
        filters.types = types;
      }
    }

    if (this.state.statuses !== undefined) {
      let statuses = [];
      this.state.statuses.forEach((status) => {
        if (status.checked === true) {
          statuses.push(status.key);
        }
      });

      if (statuses.length > 0) {
        filters.statuses = statuses;
      }
    } else {
      let statuses = [];
      this.props.state.statuses.forEach((status) => {
        if (status.checked === true) {
          statuses.push(status.key);
        }
      });

      if (statuses.length > 0) {
        filters.statuses = statuses;
      }
    }

    if (
      this.state.min_proxies !== undefined ||
      this.state.max_proxies !== undefined
    ) {
      filters.proxies = {};

      if (this.state.min_proxies !== undefined) {
        filters.proxies["min"] = this.state.min_proxies;
      }

      if (this.state.max_proxies !== undefined) {
        filters.proxies["max"] = this.state.max_proxies;
      }
    }

    if (this.state.location !== undefined) {
      filters.location = this.state.location;
    }

    if (this.state.subnet !== undefined) {
      filters.subnet = this.state.subnet;
    }

    if (
      this.state.min_cost !== undefined ||
      this.state.max_cost !== undefined
    ) {
      filters.cost = {};

      if (this.state.min_cost !== undefined) {
        filters.cost["min"] = this.state.min_cost;
      }

      if (this.state.max_cost !== undefined) {
        filters.cost["max"] = this.state.max_cost;
      }
    }

    if (this.state.usages !== undefined) {
      let usages = [];
      this.state.usages.forEach((usage) => {
        if (usage.checked) {
          usages.push(usage.slug);
        }
      });

      if (usages.length > 0) {
        filters.usages = usages;
      }
    }

    if (this.state.websites !== undefined) {
      let websites = [];
      this.state.websites.forEach((website) => {
        if (website.checked) {
          websites.push(website.id);
        }
      });

      if (websites.length > 0) {
        filters.websites = websites;
      }
    }

    if (this.state.validity !== undefined) {
      let validity = [];
      this.state.validity.forEach((valid) => {
        if (valid.checked) {
          validity.push(valid.value);
        }
      });

      if (validity.length > 0) {
        filters.validity = validity;
      }
    }

    if (this.state.concurrentConnections !== undefined) {
      let concurrentConnections = [];
      this.state.concurrentConnections.forEach((concurrentConnection) => {
        if (concurrentConnection.checked) {
          concurrentConnections.push(concurrentConnection.value);
        }
      });

      if (concurrentConnections.length > 0) {
        filters.concurrentConnections = concurrentConnections;
      }
    }

    this.props.filterProducts(filters);
  };

  updateUsageState = (usage) => {
    let usages = this.props.state.usages;

    usages.forEach((obj) => {
      if (obj.id === usage.id) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ usages }, () => {
      this.filter();
    });
  };

  updateValidState = (valid) => {
    let validity = this.props.state.validity;

    validity.forEach((obj) => {
      if (obj.value === valid.value) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ validity }, () => {
      this.filter();
    });
  };

  updateconcurrentConnectionState = (concurrentConnection) => {
    let concurrentConnections = this.props.state.concurrentConnections;

    concurrentConnections.forEach((obj) => {
      if (obj.value === concurrentConnection.value) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ concurrentConnections }, () => {
      this.filter();
    });
  };

  updateWebsiteState = (website) => {
    let websites = this.props.state.websites;

    websites.forEach((obj) => {
      if (obj.id === website.id) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ websites }, () => {
      this.filter();
    });
  };

  updateStatusState = (status) => {
    let statuses = this.props.state.statuses;

    statuses.forEach((obj) => {
      if (obj.key === status.key) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ statuses }, () => {
      this.filter();
    });
  };

  updateProductTypeState = (productType) => {
    let types = this.props.state.types;

    types.forEach((obj) => {
      if (obj.key === productType.key) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ types }, () => {
      this.filter();
    });
  };

  updateAccountTypeState = (accountType) => {
    let accountTypes = this.state.accountTypes;

    accountTypes.forEach((obj) => {
      if (obj.key === accountType.key) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ accountTypes }, () => {
      this.filter();
    });
  };

  updateSourcesState = (source) => {
    let sources = this.state.sources;

    sources.forEach((obj) => {
      if (obj.key === source.key) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ sources }, () => {
      this.filter();
    });
  };

  updateDomainState = (domain) => {
    let domains = this.state.domains;

    domains.forEach((obj) => {
      if (obj.key === domain.key) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ domains }, () => {
      this.filter();
    });
  };

  updateVerificationStatusState = (status) => {
    let verificationStatus = this.state.verificationStatus;

    verificationStatus.forEach((obj) => {
      if (obj.key === status.key) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ verificationStatus }, () => {
      this.filter();
    });
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.filter();
    });
  };

  handleChange = ({ startDate, endDate }) => {
    let changedStartDate = startDate || this.state.startDate;
    let changedEndDate = endDate || this.state.endDate;

    if (moment(changedStartDate).isAfter(moment(changedEndDate))) {
      changedEndDate = changedStartDate;
    }

    this.setState(
      { startDate: changedStartDate, endDate: changedEndDate },
      () => {
        this.filter();
      }
    );
  };

  handleChangeStart = (startDate) => this.handleChange({ startDate });

  handleChangeEnd = (endDate) => this.handleChange({ endDate });

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  render() {
    return (
      <Card className="filter-section">
        <div className="card__title">
          <h5 className="bold-text">Filters</h5>
          <FilterIcon color="#999" size={14} />
        </div>
        <div className="form wild-card-search">
          <div className="form__form-group search-bar">
            <span className="form__form-group-label">
              Search by product name
            </span>
            <div className="form__form-group-field">
              <input
                type="search"
                placeholder="Search by product name"
                name="name"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
        </div>
        <Collapse title="Product type">
          <div className="form status-filters">
            {this.props.state.types.map((productType) => (
              <div
                key={productType.key}
                className="form__form-group-field checkbox-filter-field"
              >
                <label
                  className="checkbox-btn checkbox-btn--colored"
                  htmlFor={productType.key}
                >
                  <input
                    className="checkbox-btn__checkbox"
                    type="checkbox"
                    checked={productType.checked}
                    id={productType.key}
                    onChange={() => this.updateProductTypeState(productType)}
                  />
                  <span
                    className="checkbox-btn__checkbox-custom"
                    style={
                      productType.color
                        ? {
                            background: productType.color,
                            borderColor: productType.color,
                          }
                        : {}
                    }
                  >
                    <CheckIcon />
                  </span>
                  <span className="checkbox-btn__label">
                    {productType.name}
                  </span>
                </label>
              </div>
            ))}
          </div>
        </Collapse>
        {this.state.type === "all" || this.state.type === undefined ? (
          <Collapse title="Status">
            <div className="form status-filters">
              {this.props.state.statuses.map((status) => (
                <div
                  key={"status_key_" + status.key}
                  className="form__form-group-field checkbox-filter-field"
                >
                  <label
                    className="checkbox-btn checkbox-btn--colored"
                    htmlFor={"status_id_" + status.key}
                  >
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox"
                      checked={status.checked}
                      id={"status_id_" + status.key}
                      onChange={() => this.updateStatusState(status)}
                    />
                    <span
                      className="checkbox-btn__checkbox-custom"
                      style={
                        status.color
                          ? {
                              background: status.color,
                              borderColor: status.color,
                            }
                          : {}
                      }
                    >
                      <CheckIcon />
                    </span>
                    <span className="checkbox-btn__label">{status.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse>
        ) : (
          ""
        )}
        <Collapse title="Proxies">
          <div className="form__form-group">
            <div className="form__form-group-field">
              <input
                className="react-datepicker__input-container"
                type="number"
                min="0"
                max="1000"
                placeholder="Min"
                name="min_proxies"
                onChange={this.formChangeHandler}
              />
              <span className="inputSeperator">to</span>
              <input
                className="react-datepicker__input-container"
                type="number"
                min="0"
                max="1000"
                placeholder="Max"
                name="max_proxies"
                onChange={this.formChangeHandler}
              />
            </div>
          </div>
        </Collapse>
        <Collapse title="Location">
          <div className="form__form-group">
            <div className="form__form-group-field">
              <input
                type="search"
                placeholder="Search by product Location"
                name="location"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
        </Collapse>
        <Collapse title="Subnet">
          <div className="form__form-group">
            <div className="form__form-group-field">
              <input
                type="search"
                placeholder="Search by product subnet"
                name="subnet"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
        </Collapse>
        <Collapse title="Cost">
          <div className="form__form-group">
            <div className="form__form-group-field">
              <input
                className="react-datepicker__input-container"
                type="number"
                min="0"
                max="100000"
                placeholder="Min"
                name="min_cost"
                onChange={this.formChangeHandler}
              />
              <span className="inputSeperator">to</span>
              <input
                className="react-datepicker__input-container"
                type="number"
                min="0"
                max="100000"
                placeholder="Max"
                name="max_cost"
                onChange={this.formChangeHandler}
              />
            </div>
          </div>
        </Collapse>
        <Collapse title="Subscribed Date">
          <div className="form range-pickers">
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="date-picker">
                  <DatePicker
                    selected={moment(this.state.startDate)}
                    selectsStart
                    onChange={this.handleChangeStart}
                  />
                </div>
                <div className="form__form-group-icon">
                  <CalendarBlankIcon />
                </div>
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="date-picker">
                  <DatePicker
                    selected={moment(this.state.endDate)}
                    selectsEnd
                    onChange={this.handleChangeEnd}
                  />
                </div>
                <div className="form__form-group-icon">
                  <CalendarBlankIcon />
                </div>
              </div>
            </div>
          </div>
        </Collapse>
        <Collapse title="Usages">
          <div className="form status-filters">
            {this.props.state.usages.map((usage, index) => (
              <div
                key={"usage_key" + index}
                className="form__form-group-field checkbox-filter-field"
              >
                <label
                  className="checkbox-btn checkbox-btn--colored"
                  htmlFor={usage.slug}
                >
                  <input
                    className="checkbox-btn__checkbox"
                    type="checkbox"
                    id={usage.slug}
                    onChange={() => this.updateUsageState(usage)}
                  />
                  <span className="checkbox-btn__checkbox-custom">
                    <CheckIcon />
                  </span>
                  <span className="checkbox-btn__label">{usage.name}</span>
                </label>
              </div>
            ))}
          </div>
        </Collapse>

        <Collapse title="Website">
          <div className="form status-filters">
            {this.props.state.websites.map((website, index) => (
              <div
                key={"website_key" + index}
                className="form__form-group-field checkbox-filter-field"
              >
                <label
                  className="checkbox-btn checkbox-btn--colored"
                  htmlFor={website.id}
                >
                  <input
                    className="checkbox-btn__checkbox"
                    type="checkbox"
                    checked={website.checked}
                    id={website.id}
                    onChange={() => this.updateWebsiteState(website)}
                  />
                  <span className="checkbox-btn__checkbox-custom">
                    <CheckIcon />
                  </span>
                  <span className="checkbox-btn__label">{website.name}</span>
                </label>
              </div>
            ))}
          </div>
        </Collapse>
        <Collapse title="Valid">
          <div className="form status-filters">
            {this.props.state.validity.map((valid, index) => (
              <div
                key={"valid_key" + index}
                className="form__form-group-field checkbox-filter-field"
              >
                <label
                  className="checkbox-btn checkbox-btn--colored"
                  htmlFor={"valid_" + valid.value}
                >
                  <input
                    className="checkbox-btn__checkbox"
                    type="checkbox"
                    id={"valid_" + valid.value}
                    onChange={() => this.updateValidState(valid)}
                  />
                  <span className="checkbox-btn__checkbox-custom">
                    <CheckIcon />
                  </span>
                  <span className="checkbox-btn__label">{valid.label}</span>
                </label>
              </div>
            ))}
          </div>
        </Collapse>
        {/* <Collapse title="Concurrent Connections">
          <div className="form status-filters">
            {this.props.state.concurrentConnections.map(
              (concurrentConnection, index) => (
                <div
                  key={"concurrentConnection_key" + index}
                  className="form__form-group-field checkbox-filter-field"
                >
                  <label
                    className="checkbox-btn checkbox-btn--colored"
                    htmlFor={
                      "concurrentConnection_" + concurrentConnection.value
                    }
                  >
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox"
                      id={"concurrentConnection_" + concurrentConnection.value}
                      onChange={() =>
                        this.updateconcurrentConnectionState(
                          concurrentConnection
                        )
                      }
                    />
                    <span className="checkbox-btn__checkbox-custom">
                      <CheckIcon />
                    </span>
                    <span className="checkbox-btn__label">
                      {concurrentConnection.label}
                    </span>
                  </label>
                </div>
              )
            )}
          </div>
        </Collapse> */}
      </Card>
    );
  }
}
